import ExtractList from '../../pages/Financial/Extract/List'
import Route from '../Route'
import { CustomSwitch } from '../../components/CustomSwitch'

export const ExtractRouter = (): JSX.Element => (
  <CustomSwitch>
    <Route path="/financial/extract" exact component={ExtractList} />
  </CustomSwitch>
)
